function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_503",
  "data-name": "Caminho 503",
  d: "M0,0H34.988V34.988H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_504",
  "data-name": "Caminho 504",
  d: "M15.663,16.578a2.916,2.916,0,1,1,2.916-2.916A2.924,2.924,0,0,1,15.663,16.578Zm8.747-2.624a8.752,8.752,0,1,0-17.494,0c0,3.411,2.843,7.931,8.747,13.325C21.567,21.885,24.41,17.366,24.41,13.954ZM15.663,2A11.6,11.6,0,0,1,27.326,13.954q0,7.26-11.663,17.2Q4.007,21.207,4,13.954A11.6,11.6,0,0,1,15.663,2Z",
  transform: "translate(1.831 0.916)",
  fill: "#BA122B"
});

function SvgPlaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "place_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.988,
    height: 34.988,
    viewBox: "0 0 34.988 34.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIcon);
export default __webpack_public_path__ + "static/media/placeIcon.caf54396.svg";
export { ForwardRef as ReactComponent };